import AuthService from './AuthService';
import RequestBuilder from '../Lib/Requests';

export default class RuleService {
  auth = new AuthService();
  api = new RequestBuilder();

  buildRuleCountForOrgRequest(orgID, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/metrics/rules',
      method: 'get',
      params: {
        orgID,
        orgIdFilter: orgID,
      },
      cancelToken,
    };
  }
  async fetchRuleCountForOrg(orgID = this.auth.getCurrentOrgID(), cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildRuleCountForOrgRequest(orgID, cancelToken)
    );
    return data;
  }
  buildTemplateRulesRequest(
    templateID,
    orgID = this.auth.getCurrentOrgID(),
    cancelToken
  ) {
    return {
      service: 'rules',
      endpoint: '/v1/metrics/rules',
      method: 'get',
      params: {
        orgID,
        type: 'template',
        sourceIdFilter: templateID,
      },
      cancelToken,
    };
  }
  async getTemplateRules(templateID, orgID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildTemplateRulesRequest(templateID, orgID, cancelToken)
    );
    return data;
  }
  buildRulesMetricsRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/metrics/rules',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchRulesMetrics(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildRulesMetricsRequest(params, cancelToken)
    );
    return data;
  }
  buildPaginatedRulesRequest(params, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/rules',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchPaginatedRules(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildPaginatedRulesRequest(params, cancelToken)
    );
    return data;
  }

  buildCreateRuleRequest(params, data, cancelToken) {
    return {
      service: 'rules',
      endpoint: '/v1/rules',
      method: 'post',
      params,
      data,
      cancelToken,
    };
  }
  async createRule(params, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildCreateRuleRequest(params, body, cancelToken)
    );
    return data;
  }

  buildUpdateRuleRequest(ruleID, params, data, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/rules/${ruleID}`,
      method: 'post',
      params,
      data,
      cancelToken,
    };
  }
  async updateRule(ruleID, params, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUpdateRuleRequest(ruleID, params, body, cancelToken)
    );
    return data;
  }

  buildDeleteRuleRequest(ruleID, params, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/rules/${ruleID}`,
      method: 'delete',
      params,
      cancelToken,
    };
  }
  async deleteRule(ruleID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildDeleteRuleRequest(ruleID, params, cancelToken)
    );
    return data;
  }

  buildFetchRuleRequest(ruleID, params, cancelToken) {
    return {
      service: 'rules',
      endpoint: `/v1/rules/${ruleID}`,
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchRule(ruleID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchRuleRequest(ruleID, params, cancelToken)
    );
    return data;
  }
}
